import * as React from "react";
import "../../style/header.css";
import smokelessLogo from "../../icons/smokeless_supporter_logo_h.svg";
import sideMenu from "../../icons/side_menu.svg";
import close from "../../icons/goal_not_achieved.svg";
import "../../style/App.css";
import translate from "../../translations/i18n";
import LogOutPage from "../screens/logOut";
import { connect } from "react-redux";

export interface Props {
  auth: any;
  history: any;
}

interface State {
  isPaneOpen: boolean;
}

class Header extends React.Component<Props, State> {
  private node = React.createRef<any>();

  state = {
    isPaneOpen: false,
  };

  goBack = () => {
    this.props.history.goBack();
  };

  togglePane = () => {
    if (!this.state.isPaneOpen) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }
    this.setState({ isPaneOpen: !this.state.isPaneOpen });
  };

  handleOutsideClick = (e) => {
    if (this.node.current) {
      if (!this.node.current.contains(e.target)) {
        this.togglePane();
      }
    }
  };

  showBurgerButton = () => {
    if (!this.props.auth.isEmpty) {
      return (
        <div className="SIDE_MENU_BUTTON_2" onClick={this.togglePane}>
          {!this.state.isPaneOpen && <img src={sideMenu} />}
          {this.state.isPaneOpen && <img src={close} />}
        </div>
      );
    } else return null;
  };

  render() {
    return (
      <div className="HEADER">
        <div className="HEADER_INNER">
          <div className="HEADER_GROUP_1">
            <div className="HOME_LOGO">
              <img src={smokelessLogo} />
            </div>
          </div>
          <div>
            {this.showBurgerButton()}
            {this.state.isPaneOpen && (
              <div className="SIDEBAR_CONT_2" ref={this.node}>
                <LogOutPage isOpen={this.state.isPaneOpen} />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.firebase.auth,
  };
};

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/layout/Header.tsx